import { WSContainer } from "@wingspanhq/fe-component-library";
import { WingspanProductAspects } from "@wingspanhq/users/dist/lib/interfaces";
import * as React from "react";
import { useHistory } from "react-router-dom";
import { BrowserPageTitle } from "../../components/BrowserPageTitle/BrowserPageTitle";
import { useUserId } from "../../query/hooks/helpers";
import {
  useUpdateActivity,
  useUpdateMemberProfile
} from "../../query/users/mutations";
import { useMemberProfile } from "../../query/users/queries";
import { OnboardingHeader } from "../components/OnboardingHeader/OnboardingHeader";
import { OnboardingQuestion } from "../components/OnboardingQuestion/OnboardingQuestion";

interface OnboardingStep3PaymentsProps {}

export const OnboardingStep3Payments: React.FC<OnboardingStep3PaymentsProps> = () => {
  const history = useHistory();
  const userId = useUserId();
  const [updateActivity, updateActivityMeta] = useUpdateActivity(userId);
  const qMember = useMemberProfile(userId);
  const [
    updateMemberProfile,
    updateMemberProfileMeta
  ] = useUpdateMemberProfile();
  const onBack = () => {
    history.push("/member/onboarding/step/2");
  };
  const onSubmit = async (data: any) => {
    await updateMemberProfile({
      memberId: qMember.data?.memberId as string,
      profile: {
        productAspectImportance: [data.productAspectImportance]
      }
    });
    await updateActivity({
      flows: {
        onboarding: {
          version: 3,
          currentStep: 4,
          totalSteps: 4,
          complete: false
        }
      }
    });
    history.push("/member/onboarding/step/4/payments");
  };
  return (
    <>
      <BrowserPageTitle title="Onboarding: Step 3 | Payments" />
      <OnboardingHeader onBack={onBack} />
      <WSContainer verticalPadding>
        <OnboardingQuestion
          name="productAspectImportance"
          question={{
            question: "What could be better?",
            options: [
              {
                label: "Invoicing",
                value: WingspanProductAspects.Invoicing,
                virtualAssistantMsg:
                  "Send professional invoices to new clients in less than 30 seconds. No joke. Make it recurring with one click and we’ll do the rest.",
                ctaBtnText: "Try Payments"
              },
              {
                label: "Getting paid faster",
                value: WingspanProductAspects.PaymentSpeed,
                virtualAssistantMsg:
                  "Copy your Personal Pay Link. Share it with your client. Get paid. It's actually that simple.",
                ctaBtnText: "Try Payments"
              },
              {
                label: "Managing clients",
                value: WingspanProductAspects.ClientManagement,
                virtualAssistantMsg:
                  'Never send another "following up" email again — Wingspan chases overdue invoices on your behalf.',
                ctaBtnText: "Try Payments"
              }
            ]
          }}
          onSubmit={onSubmit}
          isSubmitting={
            updateMemberProfileMeta.isLoading || updateActivityMeta.isLoading
          }
          defaultValues={{
            productAspectImportance:
              qMember.data?.profile.productAspectImportance?.[0]
          }}
        />
      </WSContainer>
    </>
  );
};
